// **
//   All of the routes for SideNav in the DigitalPass are added here,
//   You can add a new route, customize the routes and delete the routes here.

//   Once you add a new route on this file it will be visible automatically on
//   the Sidenav.

//   For adding a new route you can follow the existing routes in the routes array.
//   1. The `type` key with the `collapse` value is used for a route.
//   2. The `type` key with the `title` value is used for a title inside the Sidenav.
//   3. The `type` key with the `divider` value is used for a divider between Sidenav items.
//   4. The `name` key is used for the name of the route on the Sidenav.
//   5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
//   6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
//   7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
//   inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
//   8. The `route` key is used to store the route location which is used for the react router.
//   9. The `href` key is used to store the external links location.
//   10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
//   10. The `component` key is used to store the component of its route.
// */
// DigitalPass components
//Admin Dashboard
import React, { lazy } from "react";
import PaymentIcon from "@mui/icons-material/Payment";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AirplanemodeInactiveIcon from "@mui/icons-material/AirplanemodeInactive";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LogoutIcon from "@mui/icons-material/Logout";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupIcon from "@mui/icons-material/Group";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PostAddIcon from "@mui/icons-material/PostAdd";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// Lazy loading components
const Logout = lazy(() => import("components/Auth/Logout"));
const DashboardLayout = lazy(() => import("layout/LayoutContainers/DashboardLayout"));
const CompanyProfile = lazy(() => import("components/Dashboard/CompanyProfile"));
const NewApplication = lazy(() => import("components/Dashboard/Applications/NewApplication"));
const ApplicationList = lazy(() => import("components/Dashboard/Applications/ApplicationList"));
const ViewApplication = lazy(() => import("components/Dashboard/Applications/ViewApplication"));
const ViewUser = lazy(() => import("components/Dashboard/Users/ViewUser"));
const ExamForm = lazy(() => import("components/Dashboard/Applications/Exam/ExamForm"));
const AddNewUser = lazy(() => import("components/Dashboard/Users/AddNewUser"));
const UserList = lazy(() => import("components/Dashboard/Users/UserList"));
const DigitalPassList = lazy(() => import("components/Dashboard/Digital Passes/DigitalPassList"));
const ViewDigitalPass = lazy(() => import("components/Dashboard/Digital Passes/ViewDigitalPass"));
const TransactionList = lazy(() => import("components/Dashboard/Transactions/TransactionList"));
const SikapList = lazy(() => import("components/Dashboard/Sikaps/All Sikaps/SikapsList"));
const ViewSikap = lazy(() => import("components/Dashboard/Sikaps/View Sikap"));
const SikapExamForm = lazy(() => import("components/Dashboard/Sikaps/SikapExamForm"));
const SikapTransactionList = lazy(() =>
  import("components/Dashboard/Sikaps/SikapTransactions/SikapsTransactionList")
);
// const VehicleList = lazy(() =>
//   import("components/Dashboard/Vehicles/VehicleList")
// );
// const ViewVehicle = lazy(() =>
//   import("components/Dashboard/Vehicles/ViewVehicle")
// );
// const AddNewVehicle = lazy(() =>
//   import("components/Dashboard/Vehicles/NewVehicle")
// );
// const ViewSticker = lazy(() =>
//   import("components/Dashboard/Stickers/Sticker/ViewSticker")
// );
// const StickerList = lazy(() =>
//   import("components/Dashboard/Stickers/StickerList/StickerList")
// );
// const VehicleTransactionList = lazy(() =>
//   import("components/Dashboard/Vehicles/VehicleTransactions/VehicleTransactionList")
// );
let companyAdminRoutes = [
  {
    type: "title",
    title: "DigitalPortpasses",
    key: "digitalpass-pages",
    status: 2,
  },
  {
    type: "collapse",
    name: "Active Portpass",
    key: "/digitalpass/active",
    route: "/digitalpass/active",
    component: (
      <DashboardLayout>
        <DigitalPassList key="active" type="active" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeActiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Inactive Portpass",
    key: "/digitalpass/inactive",
    route: "/digitalpass/inactive",
    component: (
      <DashboardLayout>
        <DigitalPassList key="inactive" type="inactive" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeInactiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "All Portpass",
    key: "/digitalpass/all",
    route: "/digitalpass/all",
    component: (
      <DashboardLayout>
        <DigitalPassList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/digitalpass/:_id",
    key: "/digitalpass/:_id",
    component: (
      <DashboardLayout>
        <ViewDigitalPass />
      </DashboardLayout>
    ),
    status: 2,
  },
  { type: "divider", key: "divider-2", status: 2 },
  {
    type: "title",
    title: "Portpass Applications",
    key: "Applications",
    status: 2,
  },
  {
    type: "collapse",
    name: "Submit Admin Application",
    key: "/applications/submit",
    route: "/applications/submit",
    component: (
      <DashboardLayout>
        <NewApplication key="newApplication" />
      </DashboardLayout>
    ),
    icon: <PostAddIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/applications/examform",
    key: "exam-form",
    component: (
      <DashboardLayout>
        <ExamForm />
      </DashboardLayout>
    ),
    status: 2,
  },
  {
    type: "collapse",
    name: " New Applications Status",
    key: "/applications/new",
    route: "/applications/new",
    component: (
      <DashboardLayout>
        <ApplicationList key="new" type="new" />
      </DashboardLayout>
    ),
    icon: <PlaylistAddIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/applications/:id",
    key: "/applications/:id",
    component: (
      <DashboardLayout>
        <ViewApplication />
      </DashboardLayout>
    ),
    status: 2,
  },
  {
    type: "collapse",
    name: "All Applications Status",
    key: "/applications/all",
    route: "/applications/all",
    component: (
      <DashboardLayout>
        <ApplicationList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
    status: 2,
  },
  { type: "divider", key: "divider-4", status: 2 },
  { type: "title", title: "User", key: "user-pages", status: 2 },
  {
    type: "collapse",
    name: "Submit User Application",
    key: "/applications/submitforuser",
    route: "/applications/submitforuser",
    component: (
      <DashboardLayout>
        <NewApplication adminSubmitsForUser={true} key="adminSubmitsForUser" />
      </DashboardLayout>
    ),
    icon: <AssignmentIndIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    route: "/add-user",
    name: "Add User",
    key: "/add-user",
    icon: <PersonAddAltIcon />,
    component: (
      <DashboardLayout>
        <AddNewUser />
      </DashboardLayout>
    ),
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    route: "/users/all",
    name: "All Users",
    key: "/users/all",
    icon: <GroupIcon />,
    component: (
      <DashboardLayout>
        <UserList />
      </DashboardLayout>
    ),
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/user/:id",
    key: "/user/:id",
    component: (
      <DashboardLayout>
        <ViewUser />
      </DashboardLayout>
    ),
    status: 2,
  },
  { type: "divider", key: "divider-50", status: 2 },

  {
    type: "title",
    title: "Sikaps",
    key: "sikaps-pages",
    status: 2,
  },

  {
    type: "collapse",
    name: "All Sikaps",
    key: "/sikaps/all",
    route: "/sikaps/all",
    component: (
      <DashboardLayout>
        <SikapList key="all" type="all" />
      </DashboardLayout>
    ),

    noCollapse: true,
    icon: <FormatListBulletedIcon />,
    status: 2,
  },
  {
    type: null,
    route: "/sikaps/view/:id",
    key: "/sikaps/view/:id",
    component: (
      <DashboardLayout>
        <ViewSikap />
      </DashboardLayout>
    ),
    status: 2,
  },
  {
    type: null,
    route: "/sikaps/exam",
    key: "/sikaps/exam",
    component: (
      <DashboardLayout>
        <SikapExamForm />
      </DashboardLayout>
    ),
    status: 2,
  },
  //   { type: "divider", key: "divider-9", status: 2 },
  //   { type: "title", title: "Vehicles", key: "vehicles-pages", status: 2 },
  //   {
  //     type: "collapse",
  //     route: "/add-vehicle",
  //     name: "Add Vehicle",
  //     key: "/add-vehicle",
  //     icon: <LocalShippingIcon />,
  //     component: (
  //       <DashboardLayout>
  //         <AddNewVehicle />
  //       </DashboardLayout>
  //     ),
  //     noCollapse: true,
  //     status: 2,
  //   },
  //   {
  //     type: "collapse",
  //     name: "All Vehicles",
  //     key: "/vehicles/all",
  //     route: "/vehicles/all",
  //     component: (
  //       <DashboardLayout>
  //         <VehicleList key="all" type="all" />
  //       </DashboardLayout>
  //     ),
  //     icon: <FormatListBulletedIcon />,
  //     noCollapse: true,
  //     status: 2,
  //   },
  //   {
  //     type: null,
  //     route: "/vehicle/sticker/:id",
  //     key: "/vehicle/sticker/:id",
  //     component: (
  //       <DashboardLayout>
  //         <ViewSticker />
  //       </DashboardLayout>
  //     ),
  //     status: 2,
  //   },
  //   {
  //     type: null,
  //     route: "/vehicle/:id",
  //     key: "/vehicle/:id",
  //     component: (
  //       <DashboardLayout>
  //         <ViewVehicle />
  //       </DashboardLayout>
  //     ),
  //     status: 2,
  //   },
  //   { type: "divider", key: "divider-15", status: 2 },
  //   {
  //     type: "title",
  //     title: "Stickers",
  //     key: "sticker-pages",
  //     status: 2,
  //   },
  // {
  //   type: "collapse",
  //   name: "Active Stickers",
  //   key: "/stickers/active",
  //   route: "/stickers/active",
  //   component: (
  //     <DashboardLayout>
  //       <StickerList key="active" type="active" />
  //     </DashboardLayout>
  //   ),
  //   icon: <AirplanemodeActiveIcon />,
  //   noCollapse: true,
  //   status: 2,
  // },
  // {
  //   type: "collapse",
  //   name: "Inactive Stickers",
  //   key: "/stickers/inactive",
  //   route: "/stickers/inactive",
  //   component: (
  //     <DashboardLayout>
  //       <StickerList key="inactive" type="inactive" />
  //     </DashboardLayout>
  //   ),
  //   icon: <AirplanemodeInactiveIcon sx={{ color: 'warning.main' }} />,
  //   noCollapse: true,
  //   status: 2,
  // },
  // {
  //   type: "collapse",
  //   name: "All Stickers",
  //   key: "/stickers/all",
  //   route: "/stickers/all",
  //   component: (
  //     <DashboardLayout>
  //       <StickerList key="all" type="all" />
  //     </DashboardLayout>
  //   ),
  //   icon: <FormatListBulletedIcon />,
  //   noCollapse: true,
  //   status: 2,
  // },
  // {
  //   type: null,
  //   route: "/vehicle/sticker/:id",
  //   key: "/vehicle/sticker/:id",
  //   component: (
  //     <DashboardLayout>
  //       <ViewSticker />
  //     </DashboardLayout>
  //   ),
  //   status: 2,
  // },
  { type: "divider", key: "divider-7", status: 2 },
  {
    type: "title",
    title: "Transactions",
    key: "transaction-pages",
    status: 2,
  },
  {
    type: "collapse",
    name: "Digital Portpass Transactions",
    key: "/digitalpasses/transaction/all",
    route: "/digitalpasses/transaction/all",
    component: (
      <DashboardLayout>
        <TransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Sikaps Transactions",
    key: "/sikaps/transaction/all",
    route: "/sikaps/transaction/all",
    component: (
      <DashboardLayout>
        <SikapTransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
    status: 2,
  },

  // {
  //   type: "collapse",
  //   name: "Vehicle Transactions",
  //   key: "/vehicle/transaction/all",
  //   route: "/vehicle/transaction/all",
  //   component: (
  //     <DashboardLayout>
  //       <VehicleTransactionList key="all" type="all" />
  //     </DashboardLayout>
  //   ),
  //   icon: <PaymentIcon />,
  //   noCollapse: true,
  //   status: 2,
  // },

  { type: "divider", key: "divider-5", status: 2 },

  { type: "title", title: "Profile", key: "profile-pages", status: -10 },
  {
    type: "collapse",
    route: "/profile",
    name: "Profile",
    key: "/profile",
    icon: <AccountBoxIcon />,
    component: (
      <DashboardLayout>
        <CompanyProfile />
      </DashboardLayout>
    ),
    noCollapse: true,
    status: -10,
  },

  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "home",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
    status: -10,
  },
  { type: "divider", key: "divider-3", status: -10 },
];
export default companyAdminRoutes;
